// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssetLine_YJOr0 {
  background-color: var(--white-color);
  display: flex;
  flex-direction: column;
  gap: 10px;

  .delete_XT5Ha {
    height: 15px;
    width: 15px;
  }

  img {
    height: 50px;
    width: 50px;
  }

  .articleTitle_FQdFT {
    display: flex;
    justify-content: space-between;

    span {
      color: #92959865;
    }

    a {
      color: black;
    }
  }

  .articleBody_IWMKK {
    display: flex;
    gap: 20px;
    align-items: center;
    border-left: 1px solid #EAECF0;
    border-right: 1px solid #EAECF0;

    .grab_baWSH {
      display: flex;
      align-items: center;
      gap: 5px;
      background-color: transparent;

      button {
        background-color: transparent;
        outline: none;
        border: none;
      }

      .icon_M9pj9 {
        background-color: transparent;
        outline: none;
        border: none;
        cursor: pointer;
      }
    }

    .info_HKz_Y {
      width: 100%;
      display: flex;
      flex-direction: column;


      .test_oZ6U6 {
        width: 100%;
        display: flex;
        flex-direction: column;

        box-sizing: border-box;
        flex: 1 1;
        padding: 20px 5px 10px 0;
      }

      .leftInfo_yLTlU {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        padding-left: 15px;
        gap: 10px;
        width: 100%;
        height: 50px;

        input,
        textarea {
          font-family: "Inter", sans-serif;
        }

        textarea {
          resize: none;
          field-sizing: content;
        }

        textarea::placeholder,
        input::placeholder {
          font-family: "Inter", sans-serif;
          color: var(--_75-color);
        }
      }

    }
  }

  .leftInfo_yLTlU {

    input[disabled],
    textarea[disabled],
    select[disabled] {
      background-color: transparent;
      border: none;
      outline: none;
    }

    input {
      background-color: var(--f4-background);
      color: #75757575;
      border: none;
      outline: none;
      border-radius: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;

      div,
      span {
        height: 40px;
        background-color: red;
      }
    }
  }

}

.delete_XT5Ha {
  background-color: #dc3545;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}

.row3_XoY0n {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.input_cTXOS {}

.input_cTXOS::placeholder {
  color: #717171;
  opacity: 1;
  font-size: 14px;
}

.textRight_dZRA1 {
  display: flex;
  justify-content: end;
  align-items: end;
  color: var(--_6-color);
  font-size: 14px;
  padding-right: 15px;
}


.row3Left_Cet9H {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 50%;
}

.expandContainer_cej2c {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease, opacity 0.3s ease;
  opacity: 0;
}

.expandContainer_cej2c.open_szOQr {
  max-height: 500px;
  opacity: 1;
  width: 100%;

}

.expandContentRow1_tS6UB {
  padding: 10px 0px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: var(--_71717a-color);
}

.expandContentRow2_MZ1_c {
  padding: 10px 0px;
}

.activeBtn_CI_e5 {
  color: var(--_10a37f-background);
  stroke: #10A37F
}

.fileInfo_CzqnJ {
  display: flex;
  align-items: center;


}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/AssetLine/AssetLine.module.css"],"names":[],"mappings":"AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;;IAE9B;MACE,gBAAgB;IAClB;;IAEA;MACE,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,+BAA+B;;IAE/B;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,6BAA6B;;MAE7B;QACE,6BAA6B;QAC7B,aAAa;QACb,YAAY;MACd;;MAEA;QACE,6BAA6B;QAC7B,aAAa;QACb,YAAY;QACZ,eAAe;MACjB;IACF;;IAEA;MACE,WAAW;MACX,aAAa;MACb,sBAAsB;;;MAGtB;QACE,WAAW;QACX,aAAa;QACb,sBAAsB;;QAEtB,sBAAsB;QACtB,SAAO;QACP,wBAAwB;MAC1B;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,YAAY;;QAEZ;;UAEE,gCAAgC;QAClC;;QAEA;UACE,YAAY;UACZ,qBAAqB;QACvB;;QAEA;;UAEE,gCAAgC;UAChC,uBAAuB;QACzB;MACF;;IAEF;EACF;;EAEA;;IAEE;;;MAGE,6BAA6B;MAC7B,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,sCAAsC;MACtC,gBAAgB;MAChB,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;;MAErB;;QAEE,YAAY;QACZ,qBAAqB;MACvB;IACF;EACF;;AAEF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,cAAQ;;AAER;EACE,cAAc;EACd,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;;AAEb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;;;AAGrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.AssetLine {\n  background-color: var(--white-color);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  .delete {\n    height: 15px;\n    width: 15px;\n  }\n\n  img {\n    height: 50px;\n    width: 50px;\n  }\n\n  .articleTitle {\n    display: flex;\n    justify-content: space-between;\n\n    span {\n      color: #92959865;\n    }\n\n    a {\n      color: black;\n    }\n  }\n\n  .articleBody {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    border-left: 1px solid #EAECF0;\n    border-right: 1px solid #EAECF0;\n\n    .grab {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      background-color: transparent;\n\n      button {\n        background-color: transparent;\n        outline: none;\n        border: none;\n      }\n\n      .icon {\n        background-color: transparent;\n        outline: none;\n        border: none;\n        cursor: pointer;\n      }\n    }\n\n    .info {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n\n\n      .test {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n\n        box-sizing: border-box;\n        flex: 1;\n        padding: 20px 5px 10px 0;\n      }\n\n      .leftInfo {\n        display: flex;\n        flex-direction: row;\n        justify-content: start;\n        align-items: center;\n        padding-left: 15px;\n        gap: 10px;\n        width: 100%;\n        height: 50px;\n\n        input,\n        textarea {\n          font-family: \"Inter\", sans-serif;\n        }\n\n        textarea {\n          resize: none;\n          field-sizing: content;\n        }\n\n        textarea::placeholder,\n        input::placeholder {\n          font-family: \"Inter\", sans-serif;\n          color: var(--_75-color);\n        }\n      }\n\n    }\n  }\n\n  .leftInfo {\n\n    input[disabled],\n    textarea[disabled],\n    select[disabled] {\n      background-color: transparent;\n      border: none;\n      outline: none;\n    }\n\n    input {\n      background-color: var(--f4-background);\n      color: #75757575;\n      border: none;\n      outline: none;\n      border-radius: 8px;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n\n      div,\n      span {\n        height: 40px;\n        background-color: red;\n      }\n    }\n  }\n\n}\n\n.delete {\n  background-color: #dc3545;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n}\n\n.row3 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.input {}\n\n.input::placeholder {\n  color: #717171;\n  opacity: 1;\n  font-size: 14px;\n}\n\n.textRight {\n  display: flex;\n  justify-content: end;\n  align-items: end;\n  color: var(--_6-color);\n  font-size: 14px;\n  padding-right: 15px;\n}\n\n\n.row3Left {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 50%;\n}\n\n.expandContainer {\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.3s ease, opacity 0.3s ease;\n  opacity: 0;\n}\n\n.expandContainer.open {\n  max-height: 500px;\n  opacity: 1;\n  width: 100%;\n\n}\n\n.expandContentRow1 {\n  padding: 10px 0px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  color: var(--_71717a-color);\n}\n\n.expandContentRow2 {\n  padding: 10px 0px;\n}\n\n.activeBtn {\n  color: var(--_10a37f-background);\n  stroke: #10A37F\n}\n\n.fileInfo {\n  display: flex;\n  align-items: center;\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AssetLine": `AssetLine_YJOr0`,
	"delete": `delete_XT5Ha`,
	"articleTitle": `articleTitle_FQdFT`,
	"articleBody": `articleBody_IWMKK`,
	"grab": `grab_baWSH`,
	"icon": `icon_M9pj9`,
	"info": `info_HKz_Y`,
	"test": `test_oZ6U6`,
	"leftInfo": `leftInfo_yLTlU`,
	"row3": `row3_XoY0n`,
	"input": `input_cTXOS`,
	"textRight": `textRight_dZRA1`,
	"row3Left": `row3Left_Cet9H`,
	"expandContainer": `expandContainer_cej2c`,
	"open": `open_szOQr`,
	"expandContentRow1": `expandContentRow1_tS6UB`,
	"expandContentRow2": `expandContentRow2_MZ1_c`,
	"activeBtn": `activeBtn_CI_e5`,
	"fileInfo": `fileInfo_CzqnJ`
};
export default ___CSS_LOADER_EXPORT___;
